import { useEffect, useRef, useState } from "react";
import {
  ContainerHome,
  ContainerTitulo,
  ContainerText,
  Button
} from "../styles/home";
import Typed from "typed.js";
import "../styles/textoAutomatico.css";
import { useNavigate } from "react-router";
const TituloHome = () => {
  const el = useRef(null);
  const el2 = useRef(null);
  const typed = useRef(null);
  const navigate = useNavigate();
  const [button, setButton] = useState({aparece:false});

  useEffect(() => {
    const options1 = {
      strings: [
        '<i class="textoAutomatico">Hola,<br></i> <i class="textoAutomatico">Soy Amador,</i> <br> <i class="textoAutomatico">Desarrollador Web</i>',
      ],
      typeSpeed: 80,
      backSpeed: 80,
      startDelay: 300,
      smartBackSpace: true,
      shuffle: false,
      backDelay: 1500,
    };
    const options2 = {
      strings: ['<i class="textoAutomaticoDis">Full Stack Developer Jr.</i>'],
      typeSpeed: 80,
      backSpeed: 80,
      startDelay: 5500,
      smartBackSpace: true,
      shuffle: false,
      backDelay: 1500,
    };

    typed.current = new Typed(el.current, options1);
    typed.current = new Typed(el2.current, options2);

    return () => {
      typed.current.destroy();
    };
  }, []);

  setTimeout(() => {
  setButton((button)=>{
    return{
      ...button,
      aparece: true
    }
  })
}, 9000);


  return (
    <ContainerHome>
      <ContainerTitulo>
        <span ref={el} />
        <ContainerText>
          <span ref={el2} />
          {button.aparece && <Button onClick={()=>navigate('/contact')} >Contactame</Button>}
        </ContainerText>
      </ContainerTitulo>
    </ContainerHome>
  );
};

export default TituloHome;

